import { createContext } from "react";

const ProgressoContext = createContext();

export default ProgressoContext;